import type { TFunction } from "i18next";

export interface UpgradeBannerCopy {
  header: string;
  description: string;
}

/**
 * Returns localized upgrade-banner header/description for the side rail
 * banner shown on the study page. Mirrors the previous in-component
 * appBanners lookup keyed by APP_TO_BUILD.
 */
export function getUpgradeBannerCopy(
  t: TFunction,
  appToBuild: string,
): UpgradeBannerCopy {
  switch (appToBuild) {
    case "plumbing":
      return {
        header: t("upgrade.header_plumbing"),
        description: t("upgrade.banner_description_plumbing"),
      };
    case "electrical":
      return {
        header: t("upgrade.header_electrical"),
        description: t("upgrade.banner_description_electrical"),
      };
    case "electrical_us":
      return {
        header: t("upgrade.header_electrical_us"),
        description: t("upgrade.banner_description_electrical_us"),
      };
    case "ibew_aptitude":
      return {
        header: t("upgrade.header_ibew_aptitude"),
        description: t("upgrade.banner_description_ibew_aptitude"),
      };
    default:
      return {
        header: t("upgrade.header_electrical"),
        description: t("upgrade.banner_description_electrical"),
      };
  }
}

/**
 * Returns localized upgrade-banner copy for users who already own Pro but
 * still need an "All Access" upgrade (plumbing or electrical partialLevelAccess).
 * Mirrors mobile's getUpgradeToAllAccessBannerCopy.
 */
export function getUpgradeToAllAccessBannerCopy(
  t: TFunction,
  appToBuild: string,
): UpgradeBannerCopy {
  if (appToBuild === "plumbing") {
    return {
      header: t("upgrade.header_all_access_plumbing"),
      description: t("upgrade.banner_description_all_access_plumbing"),
    };
  }
  if (appToBuild === "electrical") {
    return {
      header: t("upgrade.header_all_access_electrical"),
      description: t("upgrade.banner_description_all_access_electrical"),
    };
  }
  return getUpgradeBannerCopy(t, appToBuild);
}
